import axios from 'axios';
import React, { useEffect } from 'react'
import {   
    useParams
  } from "react-router-dom";
import configData from "config.json";
import { UserData } from 'components/Sidebar/Sidebar_Principal';
import { authenticationService } from 'services/authentication.service';
import { authHeaderWithUserData } from 'helpers/auth-header';


type RouteParamsFiles = {
    nombre:string
}
export default function Files() {
    let {nombre} = useParams<RouteParamsFiles>()

    async function DownloadDocument(nombreDocumento:string){
        // const  regularExpresionFileName = /(?<=filename\=)[\w]*.[a-zA-Z]*(?=\;)/;
        const  regularExpresionFileName = new RegExp("(?<=filename\=)[\w]*.[a-zA-Z]*(?=\;)", 'gi');
        const URL = configData.SERVER_URL + "Files/Documento/"+nombreDocumento
        const dataUser:UserData = authenticationService.currentUserValue;
        try {
            const respuesta = await axios.get(URL,
                {
                    headers:authHeaderWithUserData(dataUser),
                    responseType:"blob"
                })
            const blobfile = respuesta.data;
            const respuestaBlob =  new Blob([blobfile]);
            let url = window.URL.createObjectURL(respuestaBlob);
           
            let a = document.createElement('a');
            a.href = url;
            const nombreArchivo:string|undefined = respuesta.headers["content-disposition"].match(regularExpresionFileName)[0]
            a.download =  nombreArchivo??"documento.pdf"  //nombrearchivo            
            a.click()
        } catch (error) {
            
        }
    }

    useEffect(() => {
        if(nombre !==""){
            DownloadDocument(nombre);
        }
        
    }, [nombre])
    
    return (
    <div></div>
  )
}
